import { NgsiIdPrefix } from '../interfaces/ngsi/entity.interface';

interface IEntityTypeConfig {
	thruster: {
		entityTypes: { DriveSystem: string }[];
	},
	compass: {
		entityTypes: { AIS: string }[];
	},
	instrumentField: {
		entityTypes: { AIS: string }[];
	}
}

export const NGSI_ENTITY_TYPES: IEntityTypeConfig = {
	thruster: {
		entityTypes: [
			{
				DriveSystem: 'DriveSystem'
			}
		]
	},
	compass: {
		entityTypes: [
			{
				AIS: 'AIS'
			}
		]
	},
	instrumentField: {
		entityTypes: [
			{
				AIS: 'AIS'
			}
		]
	}
};

export const NGSI_ENTITY_ID_PREFIX: NgsiIdPrefix = 'urn:ngsi-ld:';
